import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';

import { CoreContext } from '../../../core/context/CoreContext';
import { useDispatch, useSelector } from 'react-redux';
import FoodcompositionListTableHeader from './FoodcompositionListTableHeader';
import FoodcompositionListTableRow from './FoodcompositionListTableRow';
import IconEnabled from 'core/components/layout/IconEnabled';

export default function FoodcompositionListTable({ payload }) {

  const { showloading } = React.useContext(CoreContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const {userprofileInfo} = useSelector((state)=>state.headerslice);

  const { foodcompositionList } = useSelector((state) => state.pharmaslice.foodcompositionDashboard);
  const {filterCriteria} = useSelector((state) => state.pharmaslice.foodcompositionDashboard);
  const {sorting} = useSelector((state) => state.pharmaslice.foodcompositionDashboard);
  
  useEffect(() => {
      setRows(foodcompositionList);
  }, [foodcompositionList])

  useEffect(() => {
    let filteredList = foodcompositionList;
    if (filterCriteria.title && filterCriteria.title.trim() !== '') {
      filteredList = filteredList.filter(item =>
        item.title.toLowerCase().includes(filterCriteria.title.toLowerCase())
      );
    }
    setRows(filteredList);
  },[filterCriteria]);

  useEffect(() => {
    if (sorting.column) {
      const sortedRows = [...rows].sort((a, b) => {
        if (a[sorting.column] < b[sorting.column]) return sorting.asc ? -1 : 1;
        if (a[sorting.column] > b[sorting.column]) return sorting.asc ? 1 : -1;
        return 0;
      });
      setRows(sortedRows);
    }
  }, [sorting]);

  const handleRowClick = (rowId) => {
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }

  const getActionComponent = (rowObj) => {
    return <>
      { payload.actionList
          .filter(actionObj => 
            actionObj.status !== undefined && 
            actionObj.status.toLowerCase().includes(rowObj.orderstatusname.toLowerCase())
          )
          .map(actionObj => (
            <IconEnabled key={`${rowObj.id}-${actionObj.id}`} actionObj={actionObj} id={rowObj.id} />
  ))
      }
    </>
  }

  return (
    <>
      <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", }}>
        {/* <HEADER/> */}
        <Grid item sx={{ width: '100%', paddingBottom: .2 }}>
          {/* <HEADER - CONTAINER/> */}
          < FoodcompositionListTableHeader/>
        </Grid>
        {/* <ROWS/> */}
        <Grid item sx={{ width: '100%' }}>
          <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '65vh' }}>
              {/* <ROW CONTAINER/> */}
              <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", width: '100%' }}>

              {rows.map(obj => {
                    return (
                      < FoodcompositionListTableRow obj={obj} getActionComponent={getActionComponent} actionList={payload.actionList} handleRowClick={handleRowClick}/>
                    ) 
                })}
              {
                  rows.length === 0 ?
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ width: '100%', backgroundColor: '#fafafa' }}
                      padding={1}
                    >
                      <Typography sx={{ fontWeight: 'light', fontSize: 14 }}><i>Records(s) are not added, yet.</i></Typography>
                    </Grid>
                    : <></>
                }
               </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );


}